import FormattedList from 'I18n/components/FormattedList';
import TeamName from 'automation-ui-references/customer-data/TeamName';
import UserName from 'automation-ui-references/customer-data/UserName';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const UnifiedRoutingOwnerNames = ({
  teamIds = [],
  userIds = []
}) => /*#__PURE__*/_jsxs(FormattedList, {
  children: [userIds.map(id => /*#__PURE__*/_jsx("strong", {
    children: /*#__PURE__*/_jsx(UserName, {
      id: id
    })
  }, `user-${id}`)), teamIds.map(id => /*#__PURE__*/_jsx("strong", {
    children: /*#__PURE__*/_jsx(TeamName, {
      id: id
    })
  }, `team-${id}`))]
});
UnifiedRoutingOwnerNames.displayName = 'UnifiedRoutingOwnerNames';